import { render } from "./News-add.vue?vue&type=template&id=120e26a5&scoped=true"
import script from "./News-add.vue?vue&type=script&lang=js"
export * from "./News-add.vue?vue&type=script&lang=js"

import "./News-add.vue?vue&type=style&index=0&id=120e26a5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-120e26a5"]])

export default __exports__